import React from "react";
import nextId from "react-id-generator";
import { useHistory } from "react-router";
import { checkEmail, signUpAPI, userLogin } from "../../../../APIs/PostAPIS";
import { Images } from "../../../../Assets/0a-exporter";
import { MainContext } from "../../../Dashboard/DashboardContext/Context";
import Notification from "../../../Portals/Notification/Notification";
import "./sign-up-institute.style.scss";
export default function SignUpInstitute() {
  const context = React.useContext(MainContext);
  const { initialChecking, updateState } = context;
  const history = useHistory();
  const emailRegex = /([\w\.-]+)@([a-z\d-]+)\.([a-z]{2,8})(\.[a-z]{2,8})?/gm;
  const [loading, setLoading] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const [exist, setExist] = React.useState(null);
  const [notification, setNotification] = React.useState({
    status: false,
    title: "",
    moreDetails: "",
  });
  const [instituteDetails, setInstituteDetails] = React.useState({
    name: "",
    email: "",
    password: "",
    role_type: "institution",
  });
  const clearNotification = async (success) => {
    let res = await userLogin({
      email: instituteDetails.email,
      password: instituteDetails.password,
      role_type: "institution",
    });
    if (res.data.data) {
      updateState("userDetails", null);
      localStorage.setItem("userId", res.data.data._id);
      localStorage.setItem("iSmartID", res.data.data.iSmartID);
      localStorage.setItem("userEmail", res.data.data.email);
      localStorage.setItem("userToken", res.data.token);
      initialChecking();
      let a = setTimeout(() => {
        history.push("/register-institute");
        clearTimeout(a);
      }, 1000);
    } else {
      setNotification({
        status: true,
        title: `Something went wrong`,
        moreDetails: ``,
      });
    }
    setLoading(false);
  };
  const handleSubmit = async () => {
    try {
      setLoading(true);
      let res = await signUpAPI({
        ...instituteDetails,
      });
      if (res.data.statusCode === 200) {
        setNotification({
          status: true,
          title: `Congratulation...!!`,
          moreDetails: `${instituteDetails.name} is registered successfully`,
        });
        clearNotification(true);
      } else {
        setNotification({
          status: true,
          title: `Sorry...!!`,
          moreDetails: `${instituteDetails.name} registration failed`,
        });
      }
    } catch (error) {}
  };
  let timer;
  const checkForEmail = async () => {
    try {
      let res = await checkEmail({
        email: instituteDetails.email,
        role_type: "institution",
      });
      if (res.data.data.emailExist) {
        setExist(false);
      } else {
        setExist(true);
      }
    } catch (error) {}
  };
  const handleTimer = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      checkForEmail();
    }, 1200);
  };
  React.useEffect(() => {
    if (!instituteDetails.email || !emailRegex.test(instituteDetails.email))
      return;
    handleTimer();
  }, [instituteDetails.email]);

  // added by uzhairkhan
  // sign up button disabled or enabled
  const [disabled, setDisabled] = React.useState(null);
  React.useEffect(() => {
    setDisabled(
      !emailRegex.test(instituteDetails.email) ||
        !instituteDetails.name ||
        !instituteDetails.password ||
        !exist
    );
  }, [instituteDetails.name, instituteDetails.password, exist]);
  // added by uzhairkhan

  return (
    <div className="sign-up-institute-wrapper">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
        className="sign-up-institute-main"
      >
        <Notification
          enabled={notification.status}
          title={notification.title}
          moreDetails={notification.moreDetails}
          closeIt={() =>
            setNotification({
              status: false,
              title: "",
              moreDetails: "",
            })
          }
        />
        <div className="on-border-input">
          <span>Institute Name*</span>
          <input
            value={instituteDetails.name}
            onChange={(e) =>
              setInstituteDetails({ ...instituteDetails, name: e.target.value })
            }
            autoComplete="new-password"
            autoComplete="new"
            placeholder="High School"
            type="text"
            required
          />
        </div>
        <div
          className={`on-border-input ${
            exist !== null && !exist ? "error" : ""
          }`}
        >
          <span>Email Id*</span>
          <input
            onChange={(e) => {
              setExist(null);
              clearTimeout(timer);
              setInstituteDetails({
                ...instituteDetails,
                email: e.target.value,
              });
            }}
            value={instituteDetails.email}
            autoComplete="new-password"
            placeholder="user@gmail.com"
            type="email"
            required
          />
          <p className={exist !== null && !exist ? "" : "d-none"}>
            Email already exist.
          </p>
        </div>
        <div className="on-border-input">
          <span>Password*</span>
          <div>
          <input
            onChange={(e) =>
              setInstituteDetails({
                ...instituteDetails,
                password: e.target.value,
              })
            }
            value={instituteDetails.password}
            autoComplete="new-password"
            placeholder="*********"
            type={showPassword ? "text" : "password"}
            required
          />
          </div>
        </div>
        <div className="password-wrapper">
          <p>
            <input
              checked={showPassword}
              onChange={(e) => setShowPassword(e.target.checked)}
              type="checkbox"
            />
            Show password
          </p>
        </div>
        <button
          disabled={
            !instituteDetails.email ||
            !instituteDetails.name ||
            !instituteDetails.password ||
            !exist
          }
          className="sign-up-button"
        >
          {loading ? "Signing Up...." : "Sign Up"}
        </button>
      </form>
      <div className="line-breaker">
        <span />
        <span>Or login with</span>
        <span />
      </div>
      <div className="other-sign-up-option">
        {others.map((obj) => (
          <button key={obj.keyId}>
            <img src={obj.icon} />
          </button>
        ))}
      </div>
    </div>
  );
}

const others = [
  { keyId: nextId(), id: "google", icon: Images.google },
  { keyId: nextId(), id: "fb", icon: Images.facebook },
  { keyId: nextId(), id: "linkedIn", icon: Images.linkedLogo },
];
